<template>
  <div class="goods-detail-item">
    <!--<div class="detail-item" v-if="consultList.length" @click="bindGoConsult()">-->
    <!--<a href="javascript:;">-->
    <!--<div class="item-name-right">-->
    <!--<p class="consulting ask"><i></i>{{currentConsult.consultContent}}</p>-->
    <!--<p class="consulting answer" v-if="currentConsult.consultReply"><i></i>{{currentConsult.consultReply}}</p>-->
    <!--</div>-->
    <!--<div class="item-more-right"></div>-->
    <!--</a>-->
    <!--</div>-->
    <div class="detail-item"  @click="bindGoConsult()">
      <a href="javascript:;">
        <div class="item-name-right">
          <p class="consulting ask" data-name="有疑问?可咨询客服" style="font-size: 0.48rem;"><i></i>ေမးစရာရွိပါသလား？Customer Service သို႔႔ဆက္သြယ္ႏိုင္သည္!</p>
        </div>
        <div class="item-more-right"></div>
      </a>
    </div>
  </div>
</template>
<script>
  // js 区域


  export default {
    props: {
      consultList: {
        type: Array,
        required: false
      }
    },
    /*
     * 自身数据,一定要一个function
     */
    data() {
      return {

      }
    },
    /**
     * 计算属性
     */
    computed: {
      currentConsult : function(){
        if (!this.consultList.length) return null ;
        return this.consultList[0]
      }
    },

    /**
     * 自定义方法
     */
    methods: {
      bindGoConsult:function(){
        ga('send', 'event', '选择商品咨询按钮', '点击', '按钮点击'); //谷歌锚点
        this.$emit('goconsult');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/goods-consult/goods-consult.vue